import { cleanProps } from '../helpers';

const useCleanProps = props => cleanProps(props);

export default useCleanProps;
